import styled from 'styled-components';

import {
  scale040,
  scale080,
  scale130,
  scale140,
  scale240,
  scale260,
  scale300,
  scale320,
  scale370,
} from '@xingternal/tokens';
import { mediaConfined, mediaWideNavless } from '@xingternal/layout-tokens';

import { Button as XingternalButton } from '@xingternal/button';

import {
  sectionInnerContainerMixin,
  sectionMixin,
  CONTAINER_MAX_WIDTH,
} from '../variables.style';
import {
  BodyCopy,
  Hero as XingternalHero,
} from '../ContentSection/ContentSection.style';

import dashedLine from '../images/dashed-line.svg';

const dashedIllustrationOffset = 250;

export const Container = styled.div`
  ${sectionMixin};
  padding-top: ${scale240};
  overflow: hidden;

  @media ${mediaConfined} {
    margin-top: 0;
    padding-top: ${scale260};
  }
`;

export const InnerContainer = styled.div`
  ${sectionInnerContainerMixin};
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media ${mediaConfined} {
    flex-direction: row;
    & > * {
      flex: 0 1 50%;
      width: 50%;
    }
  }

  &::before {
    content: '';
    z-index: -1;
    background-image: url(${dashedLine});
    background-repeat: no-repeat;
    background-position: left top;
    background-size: auto ${scale320};
    position: absolute;
    height: 100%;
    top: 50%;
    transform: translateY(-50%);
    left: -${dashedIllustrationOffset}px;
    right: -${dashedIllustrationOffset}px;
    width: calc(100% + ${scale300});
    margin: 0 auto;

    @media ${mediaConfined} {
      background-size: auto ${scale370};
      background-position: left 15%;
    }

    @media ${mediaWideNavless} {
      background-position: left center;
      width: calc(100% + ${dashedIllustrationOffset * 2}px);
      max-width: calc(
        ${CONTAINER_MAX_WIDTH} + ${dashedIllustrationOffset * 2}px
      );
    }
  }
`;

export const SuggestionButton = styled(XingternalButton)`
  margin-bottom: ${scale080};
  margin-right: ${scale080};
`;

export const ImageContainer = styled.div`
  margin-bottom: ${scale140};
  display: flex;
  flex-direction: column;
  justify-content: center;

  & > img {
    width: 100%;
  }

  @media ${mediaConfined} {
    margin-right: ${scale140};
    margin-bottom: 0;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Hero = styled(XingternalHero)`
  margin-bottom: ${scale040};

  @media ${mediaConfined} {
    margin-bottom: ${scale130};
  }
`;

export const Subtitle = styled(BodyCopy)`
  @media ${mediaConfined} {
    order: -1;
  }
`;

export const CtaText = styled(BodyCopy)``;
